import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { history } from './reducer';
import Routes from './Routes';

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <ConnectedRouter history={history}>
          <Route component={ScrollToTop} />
          <Switch>
            <Routes />
          </Switch>
        </ConnectedRouter>
      </Router>
    </PersistGate>
  </Provider>
);

export default App;
